import React, { Fragment, useState } from 'react';
import { GET_ONE, UPDATE_MANY } from 'ra-core';
import { Button, useDataProvider, downloadCSV, useTranslate, useListContext, useRefresh, useUnselectAll } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ResultDialog from '../../../Utilities/ResultDialog';

function ApproveDevices () {
    const [isOpen, setIsOpen] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);
    const [resultDialogTitle, setResultDialogTitle] = useState('');

    const { selectedIds } = useListContext();

    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll("devices");

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        setResultDialogOpen(true);
        setResultLoading(true);
        setResultDialogTitle('In aggiornamento...');
        //Check all Ids statuses and ignore the ones that aren't 3
        var validIds = [];
        var invalidDevices = [];
        await asyncForEach(selectedIds, async (response) => {
            if (response.data.error) {
                //Ex: Invalid cast Id
                console.log(response.data.error.message);
            }
            else if (response.data.message) {
                //Ex: No entries found
                console.log("id: " + response.data.id + "; Message: " + response.data.message);
            }
            else if (response.data.status && response.data.status.codice === '3') {
                validIds.push(response.data.id);
            }
            else {
                //Create a list of the ones that will not be updated
                invalidDevices.push(response.data);
            }
        });
        var user = localStorage.getItem('username');
        var resultArray = [];
        let response = await dataProvider(UPDATE_MANY, 'devices', { ids: validIds, data: { status: { codice: '4' }, approved_at: new Date(), approved_by: user } }, {
            onSuccess: {
                refresh: true
            },
            onFailure: {
                notification: { body: 'tim.approvedevices.error', level: 'warning' }
            }
        })
            .catch(error => {
                console.log(error);
            });

        response.data.map(r => {
            if (r.message && r.message === "Updated") {
                resultArray.push([r.doc.serial_number_tim, r.doc.status.descrizione, <DoneIcon />, ""]);
            }
        });
        // add the ones that we didn't updated because of wrong status
        invalidDevices.map(device => {
            resultArray.push([device.serial_number_tim, device.status.descrizione, <ErrorIcon />, translate('tim.approvedevices.notValid')]);
        });
        setResultDialogOpen(true);
        setResultDialogHeaders(["Apparato", "Stato", "Risultato", "Dettaglio"]);
        setResultDialogRows(resultArray);
        setResultDialogTitle('Risultati');
        setResultLoading(false);
    };

    const asyncForEach = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
            //await callback(array[index], index, array);
            await dataProvider(GET_ONE, 'devices', { id: array[index] })
                .then(
                    response => {
                        if (response.data.message) {
                            callback(response);
                        }
                        else {
                            callback(response);
                        }
                    })
                .catch(error => {
                    callback(error);
                });
        }
    };

    /* When closing the result dialog we need to unselect the devices list
        the only way found is to perform an update, so we do a fake update */
    const handleResultClose = () => {
        refresh();
        setResultDialogOpen(false);
        setResultDialogHeaders([]);
        setResultDialogRows([[]]);
        unselectAll();
        // dataProvider(UPDATE_MANY, 'devices', { ids: [''], data: { fake: "" } }, {
        //     onSuccess: { unselectAll: true },
        //     onFailure: {
        //         unselectAll: true
        //     }
        // })
    }

    const exportToCSV = () => {
        const resultForExport = resultDialogRows.map(row => {
            const { ...resultForExport } = {};
            resultForExport.Apparato = row[0];
            resultForExport.Stato = row[1];
            resultForExport.Risultato = row[3] === "" ? "OK" : "KO";
            resultForExport.Errore = row[3];
            return resultForExport;
        })
        const csv = convertToCSV({
            data: resultForExport,
            fields: this.state.resultDialogHeaders
        });
        downloadCSV(csv, 'Risultati');
    }

        return (
            <Fragment>
                <Button label='tim.approvedevices.button_label' onClick={handleClick} >
                    <CheckIcon />
                </Button>
                <Dialog
                    open={isOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{translate('tim.approvedevices.title')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {translate('tim.approvedevices.content')}
                            <br />
                            {translate('tim.approvedevices.warning')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} label='tim.approvedevices.cancel' color="primary" autoFocus />
                        <Button onClick={handleConfirm} label='tim.approvedevices.confirm' color="primary" autoFocus />
                    </DialogActions>
                </Dialog>
                <ResultDialog
                    open={resultDialogOpen}
                    rows={resultDialogRows}
                    headers={resultDialogHeaders}
                    loading={resultLoading}
                    title={resultDialogTitle}
                    onClose={handleResultClose} >
                    {!resultLoading && <Button label='tim.approvedevices.export' onClick={exportToCSV} color="primary"></Button>}
                    {!resultLoading && <Button label='tim.approvedevices.close' onClick={handleResultClose} color="primary"></Button>}
                </ResultDialog>
            </Fragment>
        );
}

export default ApproveDevices;